<template>
    <div class="device-item" @click="onClick">
        <div class="device-item-main">
            <v-tooltip v-if="isCompact" bottom>
                <template v-slot:activator="{on, attrs}">
                    <div v-bind="attrs" v-on="on"
                         class="device-item-marker"
                         :style="{backgroundImage: 'url(' + deviceIconUrl + ')'}"
                    />
                </template>
                <span>{{ device.stateLabel }}</span>
            </v-tooltip>
            <div v-else
                 class="device-item-marker"
                 :style="{backgroundImage: 'url(' + deviceIconUrl + ')'}"
            />

            <router-link :to="`/devices/view/${device.id}`" class="device-item-name clean-link">
                {{ device.name }}
            </router-link>

            <v-spacer />

            <v-tooltip v-if="lastUpdatedAt" bottom>
                <template v-slot:activator="{on, attrs}">
                    <span v-bind="attrs" v-on="on" class="device-item-ago text--disabled">
                        {{ displayAgo(lastUpdatedAt) }}
                    </span>
                </template>
                <span>
                    {{ displayTime(lastUpdatedAt) }}
                </span>
            </v-tooltip>
            <span v-else class="device-item-ago text--disabled">
                нет данных
            </span>
        </div>

        <div v-if="!isCompact"
             class="device-item-extra text--secondary"
        >
            <span class="device-item-state">
                {{ device.stateLabel }}
            </span>

            <v-spacer />

            <span class="device-item-power">
                {{ devicePowerLabel }}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Device, getDeviceIconUrl, isDeviceDetector, isDeviceEmitter} from '@/models/Device'
import {displayAgo, displayTime} from '@/utils/datetime'

@Component
export default class SidebarDevice extends Vue
{
    @Prop({type: Object, required: true})
    device!: Device

    @Prop({type: Boolean, default: false})
    isCompact!: boolean

    displayAgo = displayAgo
    displayTime = displayTime

    get devicePowerLabel() {
        if (this.device.state === 'power:no-connection') {
            return ''
        }

        if (!this.device.lastPowerPacket) {
            return ''
        }

        return this.device.lastPowerPacket.power + ' Вт'
    }

    get lastUpdatedAt(): string|undefined {
        if (isDeviceEmitter(this.device)) {
            return this.device.lastPowerPacket?.processedAt
        }
        if (isDeviceDetector(this.device)) {
            return this.device.lastDetectorPacket?.processedAt
        }
        return undefined
    }

    get deviceIconUrl() {
        return getDeviceIconUrl(this.device)
    }

    onClick() {
        this.$emit('click', this.device)
    }
}
</script>
